import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostTicketChatMessageBody, IPostTicketChatMessage, IPostTicketChatMessageResponse } from "./post-ticket-chat-message.types";
import { IRestResponse } from "../../../types/response";

export const postTicketChatMessage: IPostTicketChatMessage = async (body: IPostTicketChatMessageBody) => {
    const response = await $api.post<IRestResponse<IPostTicketChatMessageResponse>>(`${EndpointsEnum.POST_TICKET_CHAT_MESSAGE}`, body);

    return response.data;
};
